// extracted by mini-css-extract-plugin
module.exports = {"block":"ScoutingJournalModule_block__a7MEc","footer":"ScoutingJournalModule_footer__LvWpt","none":"ScoutingJournalModule_none__folF3","list":"ScoutingJournalModule_list__mchtd"};